
import React, { Fragment, useState, useEffect, useContext, useRef } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes, faCamera } from '@fortawesome/free-solid-svg-icons'
import AppContext from '../../../contexts/AppContext'
import { Modal } from '../../UI'
import { Slides, AdvancedBanner } from '../../banners/Block'
import { SketchPicker } from 'react-color';
import { bannerPlaces, getImages, defaultBgImages, nl2br, rgbaToHtml, placementKeyBy, postToBanner, convertBanner } from '../../../services/banners'
import { PlacementTotal, Checkbox, RadioButton } from './common'
import { LocationSelector } from '../../common'
import moment from 'moment'
const useOutsideAlerter = (ref, callback) => {
    useEffect(() => {
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) {
                if(typeof callback == 'function') callback()
            }
        }

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        }
    }, [ref]);
}

const OutsideAlerter = props => {
    const wrapperRef = useRef(null);
    useOutsideAlerter(wrapperRef, props.onClick);
    return <div ref={wrapperRef}>{props.children}</div>;
}

const BannerTextProperties = ({ banner, onUpdate, prefix }) => {

    const [ showColorPicker, setShowColorPicker ] = useState(false)

    return (
        <div className="d-flex">
            <div
                className="border border-dark d-inline-block rounded me-2 cursor-pointer"
                onClick={() => setShowColorPicker(true)}
                style={{
                    backgroundColor: rgbaToHtml(banner[prefix +'Color'], '#ffffff'),
                    height: '29px',
                    width: '45px'
                }}
            />
            <div className="position-relative me-2">
                <button
                    onClick={() => setShowColorPicker(true)}
                    className="btn btn-sm btn-outline-primary"
                >Pick color</button>
                {showColorPicker &&
                    <OutsideAlerter
                        onClick={() => {
                            setShowColorPicker(false)
                        }}
                    >
                        <div
                            style={{zIndex: 1000}}
                            className="position-absolute mt-2 d-flex"
                        >
                            <SketchPicker
                                color={ banner[prefix + 'Color'] }
                                onChangeComplete={color => {
                                    onUpdate({ [prefix + 'Color']: color.rgb })
                                }}
                            />
                            <div>
                                <button
                                    onClick={() => setShowColorPicker(false)}
                                    className="ms-2 btn btn-outline-secondary"
                                >x</button>
                            </div>
                        </div>
                    </OutsideAlerter>
                }
            </div>
            <div className="me-2">
                <select
                    className="custom-select custom-select-sm"
                    onChange={e => onUpdate({ [prefix + 'FontSize']: e.target.value })}
                    value={banner[prefix + 'FontSize']}
                >
                    <option value="default">Font Size</option>
                    {[10,11,12,13,14,16,18,20,22,24,26,28,30,32,36,38,40,44,48,52,56,64,96,128].map(size =>
                        <option key={size} value={size}>{size}px</option>
                    )}
                </select>
            </div>
            <div className="me-2">
                <select
                    className="custom-select custom-select-sm"
                    onChange={e => onUpdate({ [prefix + 'FontFamily']: e.target.value })}
                    value={banner[prefix + 'FontFamily']}
                >
                    <option value="default">Font Style</option>
                    <option value="Georgia, serif">Serif</option>
                    <option value="sans-serif">Sans-serif</option>
                    <option value="monospace">Monospace</option>
                    <option value="cursive">Cursive</option>
                    <option value="fantasy">Fantasy</option>
                </select>
            </div>
            <div className="me-2">
                <Checkbox
                    active={banner[ prefix + 'Shadow' ]}
                    onChange={value => {
                        onUpdate({ [prefix + 'Shadow']: value })
                    }}
                >Text shadow</Checkbox>
            </div>
        </div>
    )
}

const TextLineEdit = ({ banner, type, max, width, bannerKey, postImages, setBanner, setUploadImage }) => {
    const bannerTitle = bannerPlaces.filter(item => bannerKey.includes(item.key))[0].name
    const [ templateType, setTemplateType ] = useState('default')
    const [ showBgColorPicker, setShowBgColorPicker ] = useState(false)

    const rawBanner = postToBanner(type, banner)

    const [ reloading, setReloading ] = useState(false)

    const _setBanner = newBanner => {
        const rawBanner = postToBanner(type, banner)
        setBanner({
            ...banner,
            ...newBanner,
            rawBanner: rawBanner
        })
        setReloading(true)
        setTimeout(() => {
            setReloading(false)
        }, 1)
    }

    const [ image, setImage ] = useState(null)

    const image_id = banner.images && banner.images[0] && banner.images[0].id

    return (
        <div className="mt-3">
            <div className="row mb-3">
                <div className="col-xl-12">
                    {['default', 'light', 'dark', 'custom'].includes(banner.templateType) &&
                        <Fragment>
                            <div className="mb-2">
                                <label className="lbl-sm">Text Ad Link URL</label>
                                <input placeholder="Text ad link URL" className="form-control form-control-sm mb-2" value={banner.linkTo} onChange={e => _setBanner({linkTo: e.target.value})} />
                            </div>
                            <div className="mb-2">
                                <label className="lbl-sm">Text Line</label>
                                <input placeholder="Text line"  className="form-control form-control-sm mb-2" value={banner.title} onChange={e => _setBanner({title: e.target.value})} />
                            </div>
                        </Fragment>
                    }
                </div>
            </div>
            {reloading &&
                <div className="bg-dark p-3 position-relative mt-2" style={{height: '60px'}} />
            }
            {!reloading &&
                <div className="bg-dark p-3 position-relative mt-2">
                    {/*
                    <TextLine items={[{
                        id: banner.id,
                        title: banner.title ? banner.title : 'Your text ad will show here',
                        link_to: banner.linkTo
                    }]} />
                    */}

                </div>
            }
        </div>
    )

}

const AdvancedBannerEdit = ({ banner, type, max, width, bannerKey, postImages, setBanner, setUploadImage }) => {

    const bannerTitle = bannerPlaces.filter(item => bannerKey.includes(item.key))[0].name
    const [ templateType, setTemplateType ] = useState('default')
    const [ showBgColorPicker, setShowBgColorPicker ] = useState(false)

    const rawBanner = postToBanner(type, banner)

    const _setBanner = newBanner => {
        const rawBanner = postToBanner(type, banner)
        setBanner({
            ...banner,
            ...newBanner,
            rawBanner: rawBanner
        })
    }

    const [ image, setImage ] = useState(null)

    const image_id = banner.images && banner.images[0] && banner.images[0].id

    return (
        <div className="mt-3">
            <div className="row mb-3">
                <div className="col-xl-6">
                    {['default', 'light', 'dark', 'custom'].includes(banner.templateType) &&
                        <Fragment>
                            <div className="mb-2">
                                <label className="lbl-sm">Banner Ad Link URL</label>
                                <input className="form-control form-control-sm mb-2" value={banner.linkTo} onChange={e => _setBanner({linkTo: e.target.value})} />
                            </div>
                            <div className="mb-2">
                                <label className="lbl-sm">Banner Ad Header</label>
                                <input className="form-control form-control-sm mb-2" value={banner.title} onChange={e => _setBanner({title: e.target.value})} />
                            </div>
                            <div className="mb-2">
                                <label className="lbl-sm">Banner Ad Description</label>
                                <textarea rows="4" className="form-control form-control-sm mb-2" value={banner.description} onChange={e => _setBanner({description: e.target.value})} />
                                asdfasdf
                            </div>
                        </Fragment>
                    }
                </div>
                <div className="col-xl-6">

                    <div className="position-relative overflow-visible">
                        <AdvancedBanner item={postToBanner(type, banner)} />
                        <div className="position-absolute p-2 m-1 rounded" style={{top: '0px', right: '0px', zIndex: 1, backgroundColor: 'rgba(0,0,0,0.125)'}}>
                            {!image &&
                                <Fragment>
                                    <input
                                        type="file"
                                        id="customFile"
                                        className="position-absolute"
                                        accept="image/png, image/jpeg"
                                        style={{
                                            height: 'calc(1.5em + 0.5rem + 2px)',
                                            paddingTop: '0.25rem',
                                            paddingBottom: '0.25rem',
                                            paddingLeft: '0.5rem',
                                            fontSize: '0.7875rem',
                                            left: "-100000px"
                                        }}
                                        onChange={e => {
                                            if (e.target.files && e.target.files[0]) {
                                                setImage(e.target.files[0])
                                                _setBanner({ images: [{id: 'custom-image', urls: {'2000_2000': URL.createObjectURL(e.target.files[0])}}] })
                                                setUploadImage(e.target.files[0])
                                            }
                                        }}
                                    />
                                    <label className="btn btn-outline-light btn-sm mb-0" htmlFor="customFile"><FontAwesomeIcon icon={faCamera} /></label>
                                </Fragment>
                            }

                            {image &&
                                <button
                                    className="btn btn-outline-light btn-sm shadow-sm mb-0"
                                    onClick={() => {
                                        setImage(null)
                                        _setBanner({images: getImages(null, postImages)})
                                    }}
                                ><FontAwesomeIcon icon={faTimes} /></button>
                            }
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )

}

const BannerEdit = ({ banner, type, max, width, bannerKey, postImages, setBanner, setUploadImage }) => {

    const bannerTitle = bannerPlaces.filter(item => bannerKey.includes(item.key))[0].name
    const [ templateType, setTemplateType ] = useState('default')
    const [ showBgColorPicker, setShowBgColorPicker ] = useState(false)

    const rawBanner = postToBanner(type, banner)

    const _setBanner = newBanner => {
        const rawBanner = postToBanner(type, banner)
        setBanner({
            ...banner,
            ...newBanner,
            rawBanner: rawBanner
        })
    }

    const [ image, setImage ] = useState(null)

    const image_id = banner.images && banner.images[0] && banner.images[0].id

    let titleMax = type == '1-room' ? 25 : (type == '2-room' ? 30 : 35)
    let descrMax = type == '1-room' ? 150 : (type == '2-room' ? 200 : 250)

    return (
        <div className="mt-3">
            <div className="row mb-3">
                <div className="col-xl-6">
                    {['default', 'light', 'dark', 'custom'].includes(banner.templateType) &&
                        <Fragment>
                            <div className="mb-2">
                                <label className="lbl-sm">Banner Ad Link URL</label>
                                <input className="form-control form-control-sm mb-2" value={banner.linkTo} onChange={e => _setBanner({linkTo: e.target.value})} />
                            </div>
                            <div className="mb-2">
                                <label className="lbl-sm">Banner Ad Header</label>
                                <input
                                    className={'form-control form-control-sm' + (banner.title?.length > titleMax ? ' is-invalid' : '')}
                                    value={banner.title}
                                    onChange={e => _setBanner({title: e.target.value})}
                                />
                                {banner.title?.length > titleMax &&
                                    <div className='invalid-feedback d-block'>
                                        Banner ad header cannot be greater than {titleMax} characters. Current description length is {banner.title?.length} characters.
                                    </div>
                                }
                            </div>
                            <div className="mb-2">
                                <label className="lbl-sm">Banner Ad Description</label>
                                <textarea
                                    rows="4"
                                    className={'form-control form-control-sm' + (banner.description?.length > descrMax ? ' is-invalid' : '')}
                                    value={banner.description} onChange={e => _setBanner({description: e.target.value})}
                                />
                                {banner.description?.length > descrMax &&
                                    <div className='invalid-feedback d-block'>
                                        Banner description ad cannot be greater than {descrMax} characters. Current description length is {banner.description?.length} characters.
                                    </div>
                                }
                            </div>
                        </Fragment>
                    }
                </div>
                {['custom'].includes(banner.templateType) &&
                    <div className="col-xl-6">
                        <div className="mb-2">
                            <small className="text-muted">Header text style</small>
                            <BannerTextProperties
                                prefix="header"
                                banner={banner}
                                onUpdate={obj => _setBanner(obj)}
                            />
                        </div>
                        <div className="mb-2">
                            <small className="text-muted">Description text style</small>
                            <BannerTextProperties
                                prefix="desc"
                                banner={banner}
                                onUpdate={obj => _setBanner(obj)}
                            />
                        </div>
                        <div className="mb-2">
                            <small className="text-muted">Background layer color</small>

                            <div className="d-flex">
                                <div
                                    className="border border-dark d-inline-block rounded me-2 cursor-pointer"
                                    onClick={() => setShowBgColorPicker(true)}
                                    style={{
                                        backgroundColor: rgbaToHtml(banner.backgroundColor, '#ffffff'),
                                        height: '29px',
                                        width: '45px'
                                    }}
                                />
                                <div className="position-relative me-2">
                                    <button
                                        onClick={() => setShowBgColorPicker(true)}
                                        className="btn btn-sm btn-outline-primary"
                                    >Pick color</button>
                                    {showBgColorPicker &&
                                        <OutsideAlerter
                                            onClick={() => {
                                                setShowBgColorPicker(false)
                                            }}
                                        >
                                            <div className="position-absolute mt-2 d-flex" style={{zIndex: 1000}}>
                                                <SketchPicker
                                                    color={ banner.backgroundColor }
                                                    onChangeComplete={color => {
                                                        _setBanner({
                                                            backgroundColor: color.rgb,
                                                            backgroundColorActive: true
                                                        })
                                                    }}
                                                />
                                                <div>
                                                    <button
                                                        onClick={() => setShowBgColorPicker(false)}
                                                        className="ms-2 btn btn-outline-secondary"
                                                    >x</button>
                                                </div>
                                            </div>
                                        </OutsideAlerter>
                                    }
                                </div>
                                <div className="me-2">
                                    <Checkbox
                                        active={banner.backgroundColorActive}
                                        onChange={value => {
                                            _setBanner({ backgroundColorActive: value })
                                        }}
                                    >Background color active</Checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
            <div className="bg-dark p-3 position-relative">
                <Slides items={[postToBanner(type, banner)]} max={max} width={width} withPlaceholder={true} confirmLink={true} />
                <div className="position-absolute p-2 m-1 rounded" style={{top: '0px', right: '0px', zIndex: 1, backgroundColor: 'rgba(0,0,0,0.125)'}}>

                    <div className="dropdown d-inline-block mr">
                        <button
                            className="btn-sm btn btn-outline-light dropdown-toggle"
                            type="button" id="templateDropDown"
                            data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
                            title="Banner templates"
                        >
                            Template: ({banner.templateType})
                        </button>
                        <div className="dropdown-menu" aria-labelledby="templateDropDown">
                            {['default', 'light', 'dark', 'custom'].map(tt => 
                                <a
                                    key={tt} href=""
                                    className={'dropdown-item text-capitalize' + (tt == banner.templateType ? ' active' : '')}
                                    onClick={e => {
                                        e.preventDefault()
                                        _setBanner({templateType: tt})
                                    }}
                                >{tt}</a>
                            )}
                        </div>
                    </div>

                    {!image &&
                        <div
                            style={{zIndex: 2}}
                            className="dropdown d-inline-block ms-2"
                            title="Background images"
                        >
                            <button className="btn-sm btn btn-outline-light dropdown-toggle" type="button" id="templateDropDown" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Images
                            </button>
                            <div className="dropdown-menu text-nowrap dropdown-menu-right" aria-labelledby="templateDropDown">
                                {defaultBgImages.map((item, i) => 
                                    <a
                                        key={item.id} href=""
                                        className={'dropdown-item text-capitalize' + (image_id == item.id ? ' active' : '')}
                                        onClick={e => {
                                            e.preventDefault()
                                            _setBanner({images: getImages(item.id, postImages)})
                                        }}
                                    >Background Image #{i}</a>
                                )}
                                {postImages && postImages.map(item => 
                                    <a
                                        key={item.id} href=""
                                        className={'dropdown-item text-capitalize' + (image_id == item.id ? ' active' : '')}
                                        onClick={e => {
                                            e.preventDefault()
                                            _setBanner({images: getImages(item.id, postImages)})
                                        }}
                                    >Image #{item.id}</a>
                                )}
                            </div>
                        </div>
                    }

                    {!image &&
                        <Fragment>
                            <input
                                type="file"
                                id="customFile"
                                className="position-absolute"
                                accept="image/png, image/jpeg"
                                style={{
                                    height: 'calc(1.5em + 0.5rem + 2px)',
                                    paddingTop: '0.25rem',
                                    paddingBottom: '0.25rem',
                                    paddingLeft: '0.5rem',
                                    fontSize: '0.7875rem',
                                    left: "-100000px"
                                }}
                                onChange={e => {
                                    if (e.target.files && e.target.files[0]) {
                                        setImage(e.target.files[0])
                                        _setBanner({ images: [{id: 'custom-image', urls: {'2000_2000': URL.createObjectURL(e.target.files[0])}}] })
                                        setUploadImage(e.target.files[0])
                                    }
                                }}
                            />
                            <label
                                title="Add image from your files"
                                className="btn btn-outline-light btn-sm mb-0 ms-2"
                                htmlFor="customFile"
                            ><FontAwesomeIcon icon={faCamera} /></label>
                        </Fragment>
                    }

                    {image &&
                        <button
                            className="btn btn-outline-light btn-sm shadow-sm mb-0 ms-2"
                            title="Add image from your files"
                            onClick={() => {
                                setImage(null)
                                _setBanner({images: getImages(null, postImages)})
                            }}
                        ><FontAwesomeIcon icon={faTimes} /></button>
                    }
                </div>
            </div>
        </div>
    )
}

const BannerExamples = ({ postImages, placement, banner, setBanner, setUploadImage }) => {

    const [ width, setWidth ] = useState(window.innerWidth)
    const updateDimensions = () => setWidth(window.innerWidth)
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);
    const maxInRow = width >= 1200 ? 3 : width >= 992 ? 2 : 1

    return (
        <div>
            {['main_full_size', 'category_full_size'].includes(placement) && <BannerEdit banner={banner} setBanner={setBanner} setUploadImage={setUploadImage} postImages={postImages} type="3-room" bannerKey={placement} max={maxInRow} width={width} />}
            {['main_two_thirds', 'category_two_thirds'].includes(placement) && <BannerEdit banner={banner} setBanner={setBanner} setUploadImage={setUploadImage} postImages={postImages} type="2-room" bannerKey={placement} max={maxInRow} width={width} />}
            {['main_one_third', 'category_one_third'].includes(placement) && <BannerEdit banner={banner} setBanner={setBanner} setUploadImage={setUploadImage} postImages={postImages} type="1-room" bannerKey={placement} max={maxInRow} width={width} />}
            {['main_text_ticker_one', 'main_text_ticker_two', 'category_text_ticker_one', 'category_text_ticker_two'].includes(placement) &&
                <TextLineEdit banner={banner} setBanner={setBanner} setUploadImage={setUploadImage} postImages={postImages} type="text-line" bannerKey={placement} max={maxInRow} width={width} />
            }
            {['main_advanced_banner'].includes(placement) && <AdvancedBannerEdit banner={banner} setBanner={setBanner} setUploadImage={setUploadImage} postImages={postImages} type="advanced" bannerKey={placement} max={maxInRow} width={width} />}
        </div>
    )
}

const BannerPreview = ({ banner }) => {
    if(!banner) return null
    const placement = placementKeyBy(banner)
    const [ width, setWidth ] = useState(window.innerWidth)
    const updateDimensions = () => setWidth(window.innerWidth)
    useEffect(() => {
        window.addEventListener("resize", updateDimensions);
        return () => window.removeEventListener("resize", updateDimensions);
    }, []);
    const maxInRow = width >= 1200 ? 3 : width >= 992 ? 2 : 1
    return (
        <div className="main-banner">
            <div className="carousel slide">
                <div className="carousel-inner">
                    <div className="active carousel-item">
                        <div className="p-3 bg-dark position-relative">
                            {['main_full_size', 'category_full_size'].includes(placement) && <Slides items={[postToBanner('3-room', convertBanner(banner))]} max={maxInRow} width={width} withPlaceholder={true} confirmLink={true} />}
                            {['main_two_thirds', 'category_two_thirds'].includes(placement) && <Slides items={[postToBanner('2-room', convertBanner(banner))]} max={maxInRow} width={width} withPlaceholder={true} confirmLink={true} />}
                            {['main_one_third', 'category_one_third'].includes(placement) && <Slides items={[postToBanner('1-room', convertBanner(banner))]} max={maxInRow} width={width} withPlaceholder={true} confirmLink={true} />}
                            {/*
                            {['main_text_ticker_one', 'main_text_ticker_two', 'category_text_ticker_one', 'category_text_ticker_two'].includes(placement) &&
                                <TextLine
                                    items={[{
                                        id: banner.id,
                                        title: banner.title,
                                        link_to: banner.link_to
                                    }]}
                                    confirmLink={true}
                                />
                            }
                            */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const Form = ({
    initBanner,
    initCategories,
    initLocations,
    initPlacement,
    initImages,
    postImages,
    initShowDialog,
    hasBeenPaid,
    updateDataToSave
}) => {

    const appContext = useContext(AppContext)
    const { data, authServices, postServices } = appContext
    const { app } = data
    const { user } = app

    const isLoggedIn = authServices.isLoggedIn()
    const isAdmin = authServices.isAdmin()
    const [ placement, setPlacement ] = useState(initPlacement)
    const [ categories, setCategories ] = useState(initCategories)
    const [ categoriesIds, setCategoriesIds ] = useState(initCategories.map(item => item.id))
    const [ locations, setLocations ] = useState(initLocations)
    const [ images, setImages ] = useState(initImages)

    const [ banner, setBanner ] = useState(initBanner)
    const [ uploadImage, setUploadImage ] = useState(null)

    const categoriesList = appContext.categories

    const [ status, setStatus ] = useState(null)

    const bannerKeys = bannerPlaces.map(item => item.key)

    const [ showDialog, setShowDialog ] = useState(null)
    const [ dialogOptions, setDialogOptions ] = useState({})
    const [ saveData, setSaveData ] = useState({})

    const modalDialog = (options) => {
        return new Promise((resolve, reject) => {
            options.onButtonClick = button => {
                if(['cancel', 'close'].includes(button)){
                    setShowDialog(null)
                    reject()
                }
                if(['okay'].includes(button)){
                    setShowDialog(null)
                    resolve()
                }
            }
            options.show = showDialog
            setDialogOptions(options)
            setShowDialog(options.dialog)
        })
    }

    const hasCategoryBanner = bannerKeys.filter(key => placement == 'category_' + key).length > 0

    const locationIds = locations && locations.map(item => item.id)

    useEffect(() => {
        if(placement){
            const type = placement ? bannerPlaces.filter(item => item.key == placement.replace('main_', '').replace('category_', ''))[0].type : null
            if(type){
                setBanner({
                    ...banner,
                    rawBanner: postToBanner(type, banner)
                })
            }
        }
        if(hasCategoryBanner && initShowDialog == 'placement'){
            setTimeout(() => {
                modalDialog({
                    title: 'Select categories',
                    buttons: ['cancel', 'okay'],
                    dialog: 'categories'
                }).then(() => {}).catch(() => {})
            }, 500)
        }
    }, [ placement ])

    useEffect(() => {
        if(initShowDialog == 'placement'){
            modalDialog({
                title: 'Placement options',
                buttons: [],
                dialog: 'placement',
                size: 'md'
            }).then(() => { }).catch(() => { })
        }
    }, [])

    const bannerTitle = placement ? bannerPlaces.filter(item => placement.includes(item.key))[0].name : null
    const type = placement ? bannerPlaces.filter(item => item.key == placement.replace('main_', '').replace('category_', ''))[0].type : null

    const _setBanner = newBanner => {
        const rawBanner = postToBanner(type, banner)
        setBanner({
            ...banner,
            ...newBanner,
            rawBanner: rawBanner
        })
    }

    const setStartDate = date => {
        //const dateDiff = moment(date).diff(moment(0,"HH"), 'days')
        _setBanner({startsAt: date})
    }

    const setEndDate = date => {
        _setBanner({expiresAt: date})
    }

    const canBePaid = !hasBeenPaid && banner.banner_status != 2

    const getSaveFormData = () => {
        const data = {
            banner: postToBanner(type, banner),
            placement: placement
        }
        if(categoriesIds && categoriesIds.length > 0 && placement.includes('category_')) data.categories = categoriesIds
        if(locations && locations.length > 0) data.locations = locations.map(item => item.id)
        if(uploadImage) data.uploadImage = uploadImage
        return data
    }

    useEffect(() => {
        updateDataToSave(getSaveFormData())
    }, [ categoriesIds.length, locations.length, uploadImage, type, banner ])

    return (
        <Fragment>

            {status && status.error && status.error.errors && status.error.errors.categories && status.error.errors.categories.map((message, i) =>
                <div key={i} className="alert alert-warning mb-3 border">{message}</div>
            )}
            {canBePaid && status && status.error && status.error.errors && (status.error.errors.starts_at || status.error.errors.expires_at) &&
                <div className="alert alert-warning mb-3 border">
                    {status.error.errors.starts_at && status.error.errors.starts_at.length > 0 && status.error.errors.starts_at.join(', ') + ' '}
                    {status.error.errors.expires_at && status.error.errors.expires_at.length > 0 && status.error.errors.expires_at.join(', ')}
                </div>
            }

            {placement &&
                <PlacementTotal
                    placement={placement}
                    categories={categoriesIds}
                    locations={locations}
                    isPlaceholder={banner.isPlaceholder}
                    startsAt={banner.startsAt}
                    expiresAt={banner.expiresAt}
                    canBePaid={canBePaid}
                    onUpdated={status => setStatus(status)}
                />
            }

            {placement &&
                <Fragment>
                    {hasCategoryBanner && canBePaid &&
                        <div className="card mb-3 flex-grow-1">
                            <div className="card-body">
                                <div className="d-flex justify-content-between flex-wrap">
                                    <div>
                                        <h3 className="me-3 my-0">Select categories</h3>
                                    </div>
                                    <div>
                                        <button
                                            type="button"
                                            className="btn btn-primary my-0"
                                            onClick={e => {
                                                e.preventDefault()
                                                modalDialog({
                                                    title: 'Select categories',
                                                    buttons: ['cancel', 'okay'],
                                                    dialog: 'categories'
                                                }).then(() => {}).catch(() => {})
                                        }}>Edit</button>
                                    </div>
                                </div>
                                {categoriesIds && categoriesIds.length > 0 &&
                                    <div className="mb-2">
                                        {categoriesList.map(root => {
                                            return (
                                                <Fragment key={root.id}>
                                                    {categories.map(item => item.id).includes(root.id) &&
                                                        <button
                                                            className="btn btn-sm bor btn-outline-primary py-1 px-2 my-1 me-2"
                                                            onClick={() => {
                                                                setCategories(categories.filter(item => item.id != root.id))
                                                                setCategoriesIds(categoriesIds.filter(id => id != root.id))
                                                            }}
                                                        >
                                                            {root.name}
                                                            <FontAwesomeIcon className="ms-2" icon={faTimes} />
                                                        </button>
                                                    }
                                                    {root.categories.filter(item => categoriesIds.includes(item.id)).map(category => {
                                                        return (
                                                            <button
                                                                key={category.id}
                                                                className="btn btn-sm bor btn-outline-secondary py-1 px-2 my-1 me-2"
                                                                onClick={() => {
                                                                    setCategories(categories.filter(item => item.id != category.id))
                                                                    setCategoriesIds(categoriesIds.filter(id => id != category.id))
                                                                }}
                                                            >
                                                                {category.name}
                                                                <FontAwesomeIcon className="ms-2" icon={faTimes} />
                                                            </button>
                                                        )
                                                    })}
                                                </Fragment>
                                            )
                                        })}
                                    </div>
                                }
                            </div>
                        </div>
                    }

                    {!banner.isPlaceholder && canBePaid &&
                        <div className="card mb-3 flex-grow-1">
                            <div className="card-body">
                                <div className="d-flex justify-content-between flex-wrap">
                                    <div className="me-3">
                                        <h3 className="">Start and end dates</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <label className="lbl-sm">Start date</label>
                                         <input
                                            type="date"
                                            className={'form-control' + (status && status.error && status.error.errors && status.error.errors.starts_at ? ' is-invalid' : '')}
                                            value={moment(banner.startsAt).format('YYYY-MM-DD')}
                                            onChange={e => setStartDate(e.target.value)}
                                        />
                                        {status && status.error && status.error.errors && status.error.errors.starts_at && <div className="invalid-feedback">{status.error.errors.starts_at}</div>}
                                    </div>
                                    <div className="col-md-6">
                                        <label className="lbl-sm">End date</label>
                                        <input
                                            type="date"
                                            className={'form-control' + (status && status.error && status.error.errors && status.error.errors.expires_at ? ' is-invalid' : '')}
                                            value={moment(banner.expiresAt).format('YYYY-MM-DD')}
                                            onChange={e => setEndDate(e.target.value)}
                                        />
                                        {status && status.error && status.error.errors && status.error.errors.expires_at && <div className="invalid-feedback">{status.error.errors.expires_at}</div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    {!banner.isPlaceholder && canBePaid &&
                        <div className="card mb-3 flex-grow-1">
                            <div className="card-body">
                                <div className="d-flex justify-content-between flex-wrap">
                                    <div className="me-3">
                                        <h3 className="">Select locations</h3>
                                    </div>
                                    <div className="flex-grow-1">
                                        <LocationSelector
                                            exclude={locations ? locations.map(item => item.id) : null}
                                            onChange={location => {
                                                setLocations([
                                                    ...locations,
                                                    {
                                                        id: location.id,
                                                        name: location.name,
                                                        type: location.type,
                                                        parent_name: location.location ? location.location.name : null,
                                                        parent_ids: [ location.parent_id, location.location ? location.location.parent_id : null ].filter(item => !!item)
                                                    }
                                                ])
                                            }}
                                        />
                                    </div>
                                </div>
                                {locations && locations.length > 0 &&
                                    <div className="mt-3">
                                        {locations.map(item => {
                                            const label = item.name + (item.parent_name ? (' ' + item.parent_name) : '')
                                            const hasOverlap = locationIds.some(id => item.parent_ids.includes(id))
                                            return (
                                                <button
                                                    key={item.id}
                                                    className={
                                                        "btn btn-sm bor py-1 px-2 my-1 me-2 btn-" + (hasOverlap ? 'light' : 'outline-primary')
                                                    }
                                                    onClick={() => {
                                                        setLocations(locations.filter(_item => _item.id != item.id))
                                                    }}
                                                >
                                                    {label}
                                                    <FontAwesomeIcon className="ms-2" icon={faTimes} />
                                                </button>
                                            )
                                        })}
                                    </div>
                                }

                                {status && status.error && status.error.errors && status.error.errors.locations &&
                                    <div className="mt-3">
                                        {status.error.errors.locations.map((message, i) =>
                                            <div key={i} className="alert alert-warning mb-0 border">{message}</div>
                                        )}
                                    </div>
                                }
                            </div>
                        </div>
                    }
                </Fragment>
            }

            <div className="card mb-3 flex-grow-1">
                <div className="card-body">
                    <div className="d-flex justify-content-between flex-wrap">
                        <div>
                            {placement ? (
                                <h3>{bannerTitle} {hasCategoryBanner ? ' (category page banner)' : ''}</h3>
                            ) : (
                                <h3>Placement options</h3>
                            )}
                        </div>
                        {isAdmin && !hasCategoryBanner &&
                            <div>
                                <Checkbox
                                    active={banner.isPlaceholder}
                                    onChange={value => {
                                        const newState = !banner.isPlaceholder
                                        _setBanner({isPlaceholder: newState})
                                    }}
                                >
                                    <abbr titlte="This option is available for administrators only. ">This is the placeholder advertisement</abbr>
                                </Checkbox>
                            </div>
                        }
                        {canBePaid &&
                            <div>
                                <button
                                    type="button"
                                    className={"btn " + (placement ? "btn-outline-primary" : "btn-primary")}
                                    onClick={e => {
                                        e.preventDefault()
                                        modalDialog({
                                            title: 'Placement options',
                                            buttons: [],
                                            dialog: 'placement',
                                            size: 'md'
                                        }).then(() => {}).catch(() => {})
                                }}>Select/Change banner placement</button>
                            </div>
                        }
                    </div>
                    {placement && 
                        <div className="main-banner">
                            <div className="carousel slide">
                                <div className="carousel-inner overflow-visible">
                                    <div className="active carousel-item">
                                        <BannerExamples
                                            banner={banner}
                                            postImages={postImages}
                                            placement={placement}
                                            setBanner={setBanner}
                                            setUploadImage={setUploadImage}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>

            <Modal {...dialogOptions} show={showDialog == 'categories'}>
                <div className="card-body">
                    {categoriesIds && categoriesList && categoriesList.map(root => {
                        const isRootActive = categoriesIds.includes(root.id)
                        const isRootOpen = isRootActive || root.categories.filter(item => categoriesIds.includes(item.id)).length > 0
                        return (
                            <Fragment key={root.id}>
                                <Checkbox
                                    active={isRootActive}
                                    onChange={value => {
                                        if(value){
                                            setCategories([...categories, root])
                                            setCategoriesIds([...categoriesIds, root.id])
                                        }else{
                                            setCategories(categories.filter(item => item.id != root.id))
                                            setCategoriesIds(categoriesIds.filter(id => id != root.id))
                                        }
                                    }}
                                ><span className="font-weight-bold">{root.name}</span></Checkbox>
                                {isRootOpen && root.categories && root.categories.length > 0 &&
                                    <div className="ms-3" style={{columnCount: 2}}>
                                        {root.categories.map(category => {
                                            const isCategoryActive = categoriesIds.includes(category.id)
                                            return (
                                                <Checkbox
                                                    key={category.id}
                                                    active={isCategoryActive}
                                                    onChange={value => {
                                                        if(value){
                                                            setCategories([...categories, category])
                                                            setCategoriesIds([...categoriesIds, category.id])
                                                        }else{
                                                            setCategories(categories.filter(item => item.id != category.id))
                                                            setCategoriesIds(categoriesIds.filter(id => id != category.id))
                                                        }
                                                    }}
                                                >{category.name}</Checkbox>
                                            )
                                        })}
                                    </div>
                                }
                            </Fragment>
                        )
                    })}
                </div>
            </Modal>

            <Modal {...dialogOptions} show={showDialog == 'placement'}>
                <div className="card-body p-3">
                    <h4 className="h5">Main page banner</h4>
                    <div className="">
                        {bannerPlaces.filter(item => item.key != 'free').map(item => 
                            <RadioButton
                                key={item.key}
                                active={placement == 'main_' + item.key}
                                onChange={value => {
                                    setPlacement('main_' + item.key, value)
                                    setShowDialog(null)
                                }}
                            >{item.name}</RadioButton>
                        )}
                    </div>
                    <h4 className="h5 mt-3 mb-2">Category page banner</h4>
                    <div className="">
                        {bannerPlaces.filter(item => item.key != 'free').map(item => 
                            <RadioButton
                                key={item.key}
                                active={placement == 'category_' + item.key}
                                onChange={value => {
                                    setPlacement('category_' + item.key, value)
                                    setShowDialog(null)
                                }}
                            >{item.name}</RadioButton>
                        )}
                    </div>
                </div>
            </Modal>

        </Fragment>
    )
}

export default Form

export { BannerExamples, BannerPreview }
